<div class="container">
  <div class="card offset xp">

    <!-- Heading -->
    <h1 class="mb-0"
      id="claim-list-heading">{{requestStatus}} WC Posting Notice Request - {{serviceRequestId}}</h1>

    <!-- Link to Service Requests Page -->
    <div class="border-bottom border-top py-2 mt-3">
      <a routerLink="/program/service-requests"
        class="icon-btn fa-chevron-left">
        {{ serviceRequestLabel.ADD_NEW_POLICY_REQ_LINK }}</a>
    </div>

    <!-- Contact Information -->
    <div class="bg-secondary bg-opacity-10 my-4">
      <div class="row px-3">
        <div class="col-auto mx-3 mt-3 mb-4">
          <h3 class="mb-0">{{ serviceRequestLabel.CONTACT_INFO }}</h3>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.INSURED_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredName}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.MAILING_RECIPIENT }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span>{{serviceRequestVOResponse?.mailingRecipient}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.FEIN_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredFein}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.COMPANY_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span>{{serviceRequestVOResponse?.company}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.CLAIM_REP_NUMBER_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.policyNumber}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.ADDRESS_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span>{{serviceRequestVOResponse?.addressLn1}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.DATE_NEEDED_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{formateDate(serviceRequestVOResponse?.dateNeeded)}}</span>
        </div>
        <div class="col-md-2 ">
          <span></span>
        </div>
        <div class="col-md-4 pb-1">
          {{serviceRequestVOResponse?.addressLn2}}
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.INSURED_ADDRESS_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredAddressLn1}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.CITY_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span>{{serviceRequestVOResponse?.city}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5">
          <span></span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredAddressLn2}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.STATE_LABEL }}</span>
        </div>
        <div class="col-md-4 ps-3  pb-1">
          <span>{{serviceRequestVOResponse?.stateCode}}</span>

        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.CITY_LABEL}}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredCity}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.ZIP_CODE_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span>{{serviceRequestVOResponse?.zipCode}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.STATE_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredStateCode}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.PHONE_LABEL }}</span>
        </div>
        <div class="col-md-2 pb-1">
          <span>{{serviceRequestVOResponse?.phoneNumber}}</span>
        </div>
        <div class="col-md-1 pt-1 ps-1 pb-1 fw-bold">
          <span>{{ serviceRequestLabel.EXTENTION_LABEL }}</span>
        </div>
        <div class="col-md-1 ps-1 pe-4 pb-1">
          <span>{{serviceRequestVOResponse?.ext}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.ZIP_CODE_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.insuredZipCode}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.PRODUCER_INFO}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerName">{{serviceRequestVOResponse?.producerVO?.producerName}}</span>
          </div>
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerAddressLn1">{{serviceRequestVOResponse?.producerVO?.producerAddressLn1}}</span>
          </div>
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerAddressLn2">{{serviceRequestVOResponse?.producerVO?.producerAddressLn2}}</span>
          </div>
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerCity">{{serviceRequestVOResponse?.producerVO?.producerCity}}</span>
            <span *ngIf="serviceRequestVOResponse?.producerVO?.producerStateDesc">,
              {{serviceRequestVOResponse?.producerVO?.producerStateDesc}}</span>
            <span *ngIf="serviceRequestVOResponse?.producerVO?.producerZipCode">,
              {{serviceRequestVOResponse?.producerVO?.producerZipCode}}</span>
          </div>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.DATE_REQUESTED_LABEL }}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{formateDate(serviceRequestVOResponse?.requestDate, true)}}</span>
        </div>
        <div class="col-md-2 fw-bold">
          <span>{{ serviceRequestLabel.TPA_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span>{{serviceRequestVOResponse?.tpaName}}</span>
        </div>
      </div>

      <div class="row px-4 contact-info-row">
        <div class="col-md-3 ps-5 fw-bold">
          <span>{{ serviceRequestLabel.REQUESTED_BY_LABEL}}</span>
        </div>
        <div class="col-md-3 pb-1">
          <span>{{serviceRequestVOResponse?.requestedBy}}</span>
        </div>
        <div class="col-md-2 pt-2">
          <span></span>
        </div>
        <div class="col-md-4 pb-1">
          <span></span>
        </div>
      </div>

      <ng-container *ngIf="requestStatus === 'Cancelled'">
        <div class="row px-4 contact-info-row">
          <div class="col-md-3 ps-5 fw-bold info-sec">
            <span>{{ serviceRequestLabel.CANCELLED_BY_LABEL}}</span>
          </div>
          <div class="col-md-3 pb-1 info-sec">
            <span>{{serviceRequestVOResponse?.completedBy}}</span>
          </div>
          <div class="col-md-2 pt-2">
            <span></span>
          </div>
          <div class="col-md-4 pb-1">
            <span></span>
          </div>
        </div>

        <div class="row px-4 contact-info-row">
          <div class="col-md-3 ps-5 fw-bold">
            <span>{{ serviceRequestLabel.CANCELLED_DATE_LABEL}}</span>
          </div>
          <div class="col-md-3 pb-1">
            <span>{{formateDate(serviceRequestVOResponse?.completionDate, true)}}</span>
          </div>
          <div class="col-md-2 pt-2">
            <span></span>
          </div>
          <div class="col-md-4 pb-1">
            <span></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="requestStatus === 'Completed'">
        <div class="row px-4 contact-info-row">
          <div class="col-md-3 ps-5 fw-bold info-sec">
            <span>{{ serviceRequestLabel.COMPLETED_BY_LABEL}}</span>
          </div>
          <div class="col-md-3 pb-1 info-sec">
            <span>{{serviceRequestVOResponse?.completedBy}}</span>
          </div>
          <div class="col-md-2 pt-2">
            <span></span>
          </div>
          <div class="col-md-4 pb-1">
            <span></span>
          </div>
        </div>

        <div class="row px-4 contact-info-row">
          <div class="col-md-3 ps-5 fw-bold">
            <span>{{ serviceRequestLabel.COMPLETED_DATE_LABEL}}</span>
          </div>
          <div class="col-md-3 pb-1">
            <span>{{formateDate(serviceRequestVOResponse?.completionDate, true)}}</span>
          </div>
          <div class="col-md-2 pt-2">
            <span></span>
          </div>
          <div class="col-md-4 pb-1">
            <span></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="requestStatus === 'Outstanding'">
        <div class="row px-4 contact-info-row">
          <div class="col-md-3 ps-5 fw-bold info-sec">
            <span>{{ serviceRequestLabel.UPDATE_STATUS_LABEL}}</span>
          </div>
          <div class="col-md-3 pb-1 info-sec">
            <span>
              <lib-select [field]="updateStatusServiceRequestConfig"
                [group]="updateServiceRequestFormGroup"
                id="updated-status-service-request"></lib-select>
              <div *ngIf="!isUpdatedStatusSelectedValid">
                <div class="text-danger add-second-alert-padding"
                  style="color:#b83b2f;margin-top:-22px;"><span class="fa fa-exclamation-circle"
                    style="color:#b83b2f;"></span> You must select a status.
                </div>
              </div>
            </span>
            <span class="d-flex justify-content-end">
              <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                class="btn-block btn-primary btn classic py-2 update-status-btn"
                (click)="updateServiceRequestStatus()">{{ serviceRequestLabel.UPDATE_STATUS_LABEL }}</button>
            </span>
          </div>
          <div class="col-md-2 pt-2">
            <span></span>
          </div>
          <div class="col-md-4 pb-1">
            <span></span>
          </div>
        </div>
      </ng-container>


    </div>

    <!-- Request Details -->
    <div class="bg-secondary bg-opacity-10 my-4">
      <div class="row px-3">
        <div class="col-auto mx-3 mt-3">
          <h3 class="mb-0">{{ serviceRequestLabel.REQUEST_DETAILS }}</h3>
        </div>
      </div>
      <div>

      </div>


      <div class="row px-4 ps-5">

        <div class="mt-4 mb-4">
          <ag-grid-angular style="width: 100%; height: 100%;"
            [rowData]="reqDetailsTableData"
            [columnDefs]="requestDetailsColumnDefs"
            [defaultColDef]="defaultColDef"
            [enableCellTextSelection]="true"
            [suppressRowClickSelection]="true"
            [suppressCellFocus]="true"
            [pagination]="totalRows > 10"
            class="ag-theme-quartz"
            overlayNoRowsTemplate="<span></span>"
            (gridReady)="onGridReadyReqDetails($event)"
            [paginationPageSize]="paginationPageSizeReqDetails"
            [paginationPageSizeSelector]="paginationPageSizeSelectorReqDetails"></ag-grid-angular>

        </div>
        <div class="margin">
          <div class="text-center font-weight-bold"
            *ngIf="reqDetailsTableData.length===0">{{
            serviceRequestLabel.NO_RECORD_FOUND_TXT }}</div>
        </div>
        <div *ngIf="reqDetailsTableData.length > 0">
          <div class="bg-primary text-white px-2">Policies: {{reqDetailsTableData.length}}</div>
        </div>
        <hr>
        <div class="requestsContainer">
          <div class="requestTemplate">
            <div class="row">
              <div class="col-md-3 pe-0 fw-bold">
                <span>{{serviceRequestLabel.TOTAL_NUMBER_REQUESTED}}</span>
              </div>
              <div class="col-md-1 ps-0 pe-0 fw-bold">
                <span>{{serviceRequestLabel.TOTAL_PAPER_COUNT}}</span>
              </div>
              <div class="col-md-1 ps-0 pe-0">
                <span>{{serviceRequestVOResponse?.totalPaperCopy}}</span>
              </div>
              <div class="col-md-1 pe-0 fw-bold">
                <span>{{serviceRequestLabel.TOTAL_EMAIL_COUNT}}</span>
              </div>
              <div class="col-md-1 ps-0 pe-0">
                <span>{{serviceRequestVOResponse?.totalEmailCopy}}</span>
              </div>
              <div class="pe-0 fw-bold"
                [ngClass]="{'col-md-2': serviceRequestVOResponse?.postingEmailAddress, 'col-md-3': !serviceRequestVOResponse?.postingEmailAddress}">
                <span>{{serviceRequestLabel.POSTING_NOTICE_EMAIL_ADDRESS}}</span>
              </div>
              <div class="col-md-3 ps-0"
                style="white-space: normal;
              word-wrap: break-word;
              overflow-wrap: break-word;"
                *ngIf="serviceRequestVOResponse?.postingEmailAddress">
                <span>{{serviceRequestVOResponse?.postingEmailAddress}}</span>
              </div>
            </div>

            <div class="row"
              *ngIf="serviceRequestVOResponse?.requestCommentVO?.[0]?.commentText">
              <div class="md-12 pb-2 fw-bold pt-3"><span>{{serviceRequestLabel.COMMENTS_LABEL}}</span></div>
              <div class="md-12">{{serviceRequestVOResponse?.requestCommentVO?.[0]?.commentText}}
              </div>
            </div>
          </div>
        </div>


      </div>
      <!-- Select Additional Recipients to Receive Status Updates (Optional) -->
      <div class="my-4">
        <div class="row px-0">
          <div class="col-md-12 mx-0 mt-3">
            <lib-accordion #accordion>
              <div libAccordionPanel
                [id]="'selectAdditionalRecipientsId'"
                customPanelClass="custom-panel-class"
                [customTitle]="selectAdditionalRecipientsTitle"
                [body]="selectAdditionalRecipientsBody"
                [expanded]="true"></div>
            </lib-accordion>
            <ng-template #selectAdditionalRecipientsBody>


              <div class="mt-4 mb-4">
                <div class="lmrm">

                  <div class="grid-container">
                    <ag-grid-angular style="width: 60%; height: 100%;"
                      [rowData]="additionalReceipentsTableData"
                      [columnDefs]="additionalRecipientsColumnDefs"
                      [defaultColDef]="defaultColDef"
                      [rowSelection]="'multiple'"
                      [rowMultiSelectWithClick]="true"
                      [enableCellTextSelection]="true"
                      [suppressRowClickSelection]="false"
                      [pagination]="false"
                      class="ag-theme-quartz"
                      overlayNoRowsTemplate="<span></span>"
                      (gridReady)="onGridReadyAddReceipents($event)"
                      [paginationPageSize]="paginationPageSizeAddReceipents"
                      [paginationPageSizeSelector]="paginationPageSizeSelectorAddReceipents"
                      (cellClicked)="onCellClickedAddRecp($event)"
                      (selectionChanged)="onSelectionChangedAddReceipents()"></ag-grid-angular>
                    <div style="width: 60%;"
                      class="text-center font-weight-bold no-records-text"
                      *ngIf="additionalReceipentsTableData.length===0">{{
                      serviceRequestLabel.NO_RECORD_FOUND_TXT }}</div>
                  </div>

                </div>

              </div>


            </ng-template>

            <ng-template #selectAdditionalRecipientsTitle
              let-panelData="panelData">
              <div class="title-wrapper">
                <span class="icon icon-caret-down pull-left px-2 pt-1 expanded"></span>
                <div class="flex-col">
                  <span class="col h4">{{ accordianData[0].title }} </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Attach Files (optional) -->
      <div class="my-4">
        <div class="row px-0">
          <div class="col-md-12 mx-0 mt-3">
            <lib-accordion #accordion>
              <div libAccordionPanel
                [id]="'attachFilesId'"
                customPanelClass="custom-panel-class"
                [customTitle]="attachFilesTitle"
                [body]="attachFilesBody"
                [expanded]="true"></div>
            </lib-accordion>


            <ng-template #attachFilesBody>
              <div class="lmrm">
                <div class="download-link pt-2"
                  *ngFor="let file of serviceRequestVOResponse?.serviceRequestAttachmentVO">
                  <a (click)="downloadFile(file)">{{file.attachmentShortName}}</a>
                </div>
              </div>


            </ng-template>
            <ng-template #attachFilesTitle
              let-panelData="panelData">
              <div class="title-wrapper"
                (click)="handleOnToggle($event)">
                <span class="icon icon-caret-down pull-left px-2 pt-1 expanded"></span>
                <div class="flex-col">
                  <span class="col h4">{{ accordianData[1].title }} </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div>
      </div>
    </div>